import { render, staticRenderFns } from "./crownButton.vue?vue&type=template&id=7403001b&scoped=true&"
import script from "./crownButton.vue?vue&type=script&lang=js&"
export * from "./crownButton.vue?vue&type=script&lang=js&"
import style0 from "./crownButton.vue?vue&type=style&index=0&id=7403001b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7403001b",
  null
  
)

export default component.exports